"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = exports.envUrls = exports.envKeys = void 0;
const react_1 = require("react");
const hooks_1 = require("@pulse-web-platform-core/hooks");
const cachedDataConfig = (() => {
    var _a;
    const rootEl = document.getElementById('pulseRoot');
    if (rootEl) {
        try {
            return JSON.parse((_a = rootEl.getAttribute('data-config')) !== null && _a !== void 0 ? _a : '{}');
        }
        catch (error) {
            console.error('Error parsing data-config:', error);
            return {};
        }
    }
    return {};
})();
const getDataConfig = () => cachedDataConfig;
const cachedYaCounterKey = (() => {
    var _a, _b, _c;
    const searchParams = new URLSearchParams(window.location.search);
    const dataConfig = getDataConfig();
    return ((_c = (_b = (_a = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.ymKeys) === null || _a === void 0 ? void 0 : _a.yaCounterKeyName) !== null && _b !== void 0 ? _b : searchParams.get('ya_counter_key_name')) !== null && _c !== void 0 ? _c : 'YM_COUNTER_KEY');
})();
exports.envKeys = {
    YM_COUNTER_KEY: Number(window.envKeys[cachedYaCounterKey]),
    AMPLITUDE_API_KEY: String(window.envKeys.AMPLITUDE_API_KEY),
    MY_TRACKER_KEY: Number(window.envKeys.MY_TRACKER_KEY),
    ADRIVER_KEY: Number(window.envKeys.ADRIVER_KEY),
    ADRIVER_KEY2: Number(window.envKeys.ADRIVER_KEY2),
    AMPLITUDE_AGENT_API_KEY: String(window.envKeys.AMPLITUDE_AGENT_API_KEY),
    CPA_SCALEO_TOKEN: String(window.envKeys.CPA_SCALEO_TOKEN),
    DADATA_KEY: String(window.envKeys.DADATA_KEY),
    UNICOM24_CAMPAIGN: String(window.envKeys.UNICOM24_CAMPAIGN),
    UNICOM24_PARTNER_CODE: String(window.envKeys.UNICOM24_PARTNER_CODE),
    YM_AGENT_COUNTER_KEY: String(window.envKeys.YM_AGENT_COUNTER_KEY),
    CAPTCHA_CLIENT_KEY: String(window.envKeys.CAPTCHA_CLIENT_KEY),
};
exports.envUrls = {
    STORAGE_URL: String(window.envUrls.STORAGE_URL),
    BASEURL: String(window.envUrls.BASEURL),
    BEST2PAY_API_URL: String(window.envUrls.BEST2PAY_API_URL),
    INSURANCE_MOBILE_APP_HOT_LINK: String(window.envUrls.INSURANCE_MOBILE_APP_HOT_LINK),
    UNICOM_24_POSTBACK_URL: String(window.envUrls.UNICOM_24_POSTBACK_URL),
    AGENT_URL: String(window.envUrls.AGENT_URL),
};
const useConfig = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const searchParams = (0, hooks_1.useQuerySearch)();
    const dataConfig = cachedDataConfig;
    const [baseConfig] = (0, react_1.useState)({
        isIframe: (_a = dataConfig.isIframe) !== null && _a !== void 0 ? _a : false,
        personalization: (_b = dataConfig.personalization) !== null && _b !== void 0 ? _b : searchParams.get('personalization'),
        preset: (_c = dataConfig.preset) !== null && _c !== void 0 ? _c : searchParams.get('preset'),
        phone: (_d = dataConfig.phone) !== null && _d !== void 0 ? _d : searchParams.get('phone'),
        platform: (_e = dataConfig.platform) !== null && _e !== void 0 ? _e : searchParams.get('platform'),
        utm: {
            utm_source: (_g = (_f = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _f === void 0 ? void 0 : _f.utm_source) !== null && _g !== void 0 ? _g : searchParams.get('utm_source'),
            utm_campaign: (_j = (_h = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _h === void 0 ? void 0 : _h.utm_campaign) !== null && _j !== void 0 ? _j : searchParams.get('utm_campaign'),
            utm_content: (_l = (_k = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _k === void 0 ? void 0 : _k.utm_content) !== null && _l !== void 0 ? _l : searchParams.get('utm_content'),
            utm_medium: (_o = (_m = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _m === void 0 ? void 0 : _m.utm_medium) !== null && _o !== void 0 ? _o : searchParams.get('utm_medium'),
            utm_media_source: (_q = (_p = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _p === void 0 ? void 0 : _p.utm_media_source) !== null && _q !== void 0 ? _q : searchParams.get('utm_media_source'),
            campaign: (_s = (_r = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _r === void 0 ? void 0 : _r.campaign) !== null && _s !== void 0 ? _s : searchParams.get('campaign'),
            media_source: (_u = (_t = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _t === void 0 ? void 0 : _t.media_source) !== null && _u !== void 0 ? _u : searchParams.get('media_source'),
            wm_id: (_w = (_v = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.utm) === null || _v === void 0 ? void 0 : _v.wm_id) !== null && _w !== void 0 ? _w : searchParams.get('wm_id'),
        },
        components: (_x = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.components) !== null && _x !== void 0 ? _x : searchParams.get('components'),
    });
    return (0, react_1.useMemo)(() => {
        var _a;
        const agentLogin = (_a = dataConfig.agentLogin) !== null && _a !== void 0 ? _a : searchParams.get('agent_login');
        return Object.assign(Object.assign({}, baseConfig), { agentLogin,
            envKeys: exports.envKeys,
            envUrls: exports.envUrls });
    }, [searchParams]);
};
exports.useConfig = useConfig;
